module.exports = __webpack_public_path__ + "static/img/image085.666f209.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image085.png
// module id = V1S2
// module chunks = 1